import { useEffect } from "react";

// Extra settle delay beyond the list's own search debounce, so a zero-match intermediate term doesn't escalate mid-typing.
const ESCALATION_SETTLE_DELAY_MS = 500;

interface UseResetFilterOnEmptySearchParams {
  // True when there's no broader filter/tab left to fall back to.
  isAlreadyBroadest: boolean;
  isReady: boolean;
  onSwitchToAll: () => void;
  searchTerm?: string;
  totalMatches: number;
}

// Switches to the broadest filter/tab when a search has zero matches in the current scope. See MBNLC-1661.
export function useResetFilterOnEmptySearch({
  isAlreadyBroadest,
  isReady,
  onSwitchToAll,
  searchTerm,
  totalMatches,
}: UseResetFilterOnEmptySearchParams) {
  useEffect(() => {
    if (!searchTerm || isAlreadyBroadest || !isReady || totalMatches > 0) {
      return;
    }

    const timer = setTimeout(onSwitchToAll, ESCALATION_SETTLE_DELAY_MS);

    return () => clearTimeout(timer);
  }, [searchTerm, isAlreadyBroadest, isReady, totalMatches, onSwitchToAll]);
}
